import { gql } from '@apollo/client'
import { PDNFragments } from '../fragments/productDetailNote.fragment'

export const AddProductDetailNote = gql`
    mutation addProductDetailNote(
        $addProductDetailNoteInput: ProductDetailNoteInput!
    ) {
        addProductDetailNote(input: $addProductDetailNoteInput) {
            ...pdnCommonFragment
            metadata {
                ...pdnMetadata
            }
        }
    }
    ${PDNFragments.pdnCommonFragment}
    ${PDNFragments.pdnMetadata}
`

export const DeleteProductDetailNote = gql`
    mutation deleteProductDetailNote($productDetailNoteId: String!) {
        deleteProductDetailNote(productDetailNoteId: $productDetailNoteId) {
            ...pdnCommonFragment
            isDeleted
            metadata {
                ...pdnMetadata
            }
        }
    }
    ${PDNFragments.pdnCommonFragment}
    ${PDNFragments.pdnMetadata}
`

export const MarkProductDetailNoteAsSeen = gql`
    mutation markProductDetailNoteAsSeen(
        $input: MarkProductDetailNoteAsSeenInput!
    ) {
        markProductDetailNoteAsSeen(input: $markProductDetailNoteAsSeenInput) {
            ...pdnCommonFragment
            isDeleted
            metadata {
                ...pdnMetadata
            }
        }
    }
    ${PDNFragments.pdnCommonFragment}
    ${PDNFragments.pdnMetadata}
`

export const UpdateProductDetailNote = gql`
    mutation updateProductDetailNote(
        $productDetailNoteId: String!
        $updateProductDetailNoteInput: ProductDetailNoteInput!
    ) {
        updateProductDetailNote(
            productDetailNoteId: $productDetailNoteId
            input: $updateProductDetailNoteInput
        ) {
            ...pdnCommonFragment
            metadata {
                ...pdnMetadata
            }
        }
    }
    ${PDNFragments.pdnCommonFragment}
    ${PDNFragments.pdnMetadata}
`
